import { createClient } from 'sizebay-core-sdk';

const envVar = (import.meta.env.VITE_SIZEBAY_IA_ENVIRONMENT as 'production' | 'development') || 'development';

export const sizebayClient = createClient({
  env: envVar,
});
